/* import __COLOCATED_TEMPLATE__ from './footer.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

export interface BvCardFooterSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const BvCardFooterComponent = templateOnlyComponent<BvCardFooterSignature>();

export default BvCardFooterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvCard::Footer': typeof BvCardFooterComponent;
    'bv-card/footer': typeof BvCardFooterComponent;
  }
}
